import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { AddCircleOutline, BugReport, ChangeCircle, CreateNewFolder, Delete, DriveFileMoveRounded, GpsFixed, Outbox, PrecisionManufacturing, RocketLaunch, Settings, } from '@mui/icons-material';
import { can_locate_device, can_manage_groups, can_send_to_test_server, } from 'console/account/account_tsx';
import branding from 'shared/app/model/branding';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { openDeleteDialog } from 'console/leftPanel/deleteDeviceDialog/actions';
import { openMiniMap } from 'widgets/map.corner/model/actions';
import { preventDefault, useCallbacks, usePartial } from 'shared/hooks/utils';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { open_replace_dialog } from 'console/replaceDeviceDialog/actions';
import { select_current_account_id } from 'console/redux/selectors';
import { addGroupInDeviceTree } from 'console/redux/devices/tree/actions';
import { openGroupNameDialog } from 'console/sortableDeviceTree/rename-group-dialog/actions';
import { openTransferDialog } from 'console/transferDeviceDialog/actions';
import { UniversalMenu } from 'console/shared/components/menu';
import * as S from './styles';
import { useSelectDeviceTreeGroupDialog } from 'console/left-menu/set-device-tree-group';
import { useOpenDeviceSettings } from 'features/device.settings.open/lib';
import { useKeybindControlMenu } from 'console/left-menu/model/use-keybind-control-menu';
import { useSendToServer } from 'console/left-menu/send-server';
export const DeviceControlMenu = memo(function DeviceControlMenu(props) {
    const { closeMenus, anchor, addDevice, openProPopup, onClose, gps_state, device_id, user_id, device_name, } = props;
    const can_take_changes_groups = useAppSelector(can_manage_groups);
    const can_take_locate_device = useAppSelector(can_locate_device);
    const can_staff_send_to_test_server = useAppSelector(can_send_to_test_server);
    const account_id = useAppSelector(select_current_account_id);
    const deleteDevice = useCallbacks([closeMenus, useAction(openDeleteDialog)]);
    const transfer = useCallbacks([closeMenus, useAction(openTransferDialog)]);
    const replace = useCallbacks([closeMenus, useAction(open_replace_dialog)]);
    const locateDevice = useCallbacks([
        closeMenus,
        preventDefault,
        useAction(usePartial(openMiniMap, device_id)),
    ]);
    const [SelectDeviceGroup, openSelectDeviceGroup] = useSelectDeviceTreeGroupDialog();
    const transferInGroup = useCallbacks([openSelectDeviceGroup, onClose]);
    const addGroup = useCallbacks([
        closeMenus,
        usePartial(useAction(openGroupNameDialog), '', useAction(usePartial(addGroupInDeviceTree, []))),
    ]);
    const [show_settings_button, onOpenDeviceSettings] = useOpenDeviceSettings(device_id);
    const onSendToServer = useSendToServer(device_id);
    const menu_items = useMemo(() => [
        {
            icon: _jsx(RocketLaunch, { color: "primary" }),
            label: 'Добавить группу',
            onClick: openProPopup,
            show: branding.enable_zont_billing && !can_take_changes_groups,
        },
        {
            icon: _jsx(CreateNewFolder, { color: "action" }),
            label: 'Добавить группу',
            onClick: addGroup,
            show: can_take_changes_groups,
        },
        {
            icon: _jsx(AddCircleOutline, { color: "action" }),
            label: 'Добавить новое устройство',
            onClick: addDevice,
            divider: {
                content: (_jsx(S.DeviceName, { label: device_name, color: "textSecondary", children: device_name })),
            },
        },
        {
            icon: _jsx(Settings, { color: "action" }),
            label: 'Открыть настройки',
            onClick: onOpenDeviceSettings,
            show: show_settings_button,
        },
        {
            icon: _jsx(DriveFileMoveRounded, { color: "action" }),
            label: 'Переместить в группу',
            onClick: transferInGroup,
            show: can_take_changes_groups,
        },
        {
            icon: _jsx(Outbox, { color: "action" }),
            label: 'Передать в другой аккаунт',
            onClick: transfer,
            show: user_id === account_id,
        },
        {
            icon: _jsx(ChangeCircle, { color: "action" }),
            label: 'Заменить устройство',
            onClick: replace,
        },
        {
            icon: _jsx(GpsFixed, { color: "action" }),
            label: 'Отслеживать устройство',
            onClick: locateDevice,
            show: can_take_locate_device && gps_state != null && isMediumUI(),
        },
        {
            icon: _jsx(Delete, { color: "action" }),
            label: 'Удалить из аккаунта',
            onClick: deleteDevice,
        },
        {
            icon: _jsx(BugReport, { color: "action" }),
            label: 'Отправить на тестовый сервер',
            onClick: () => onSendToServer(true),
            show: can_staff_send_to_test_server,
        },
        {
            icon: _jsx(PrecisionManufacturing, { color: "action" }),
            label: 'Отправить на боевой сервер',
            onClick: () => onSendToServer(false),
            show: can_staff_send_to_test_server,
        },
    ], [
        can_take_changes_groups,
        can_take_locate_device,
        user_id,
        gps_state,
        device_name,
        account_id,
        show_settings_button,
        onOpenDeviceSettings,
        addDevice,
        device_id,
    ]);
    useKeybindControlMenu({
        onOpenDeviceSettings,
        replace,
        deleteDevice,
        addDevice,
        addGroup,
        show_settings_button,
        user_id,
        account_id,
        transfer,
        can_take_changes_groups,
    });
    return (_jsxs(_Fragment, { children: [_jsx(UniversalMenu, { anchor: anchor, menu_items: menu_items, opened: !!anchor, onClose: onClose }), _jsx(SelectDeviceGroup, {})] }));
});
